import jQuery from 'jquery';

const CUSTOMIZE_SETTINGS_COOKIE_EXPIRES = 365;

export const customizeSettingsConfig = {
    form: {
        name: 'form',
        displayName: 'Form',
        switcherSelector: '.js-RC-customizeSettings__switcher_form',
        elementSelector: '.RC-runnerForm',
        elementHiddenClass: 'RC-runnerForm_hidden',
        btnCardSelector: '.js-RC-runnerFormBtn',
        btnCardActiveClass: 'RC-runnerButtons__item_active'
    },
    myNotes: {
        name: 'myNotes',
        displayName: 'My Notes',
        switcherSelector: '.js-RC-customizeSettings__switcher_myNotes',
        elementSelector: '.RC-notes',
        elementHiddenClass: 'RC-notes_hidden',
        btnCardSelector: '.js-RC-runnerNotesBtn',
        btnCardActiveClass: 'RC-runnerButtons__item_active'
    },
    spotlights: {
        name: 'spotlights',
        displayName: 'Spotlights',
        switcherSelector: '.js-RC-customizeSettings__switcher_spotlights',
        elementSelector: '.RC-spotlight',
        elementHiddenClass: 'RC-spotlight_hidden',
        btnCardSelector: '.js-RC-runnerSpotlightBtn',
        btnCardActiveClass: 'RC-runnerButtons__item_active'
    },
    comments: {
        name: 'comments',
        displayName: 'Comments',
        switcherSelector: '.js-RC-customizeSettings__switcher_comments',
        elementSelector: '.RC-comments',
        elementHiddenClass: 'RC-comments_hidden',
        btnCardSelector: '.js-RC-runnerCommentsBtn',
        btnCardActiveClass: 'RC-runnerButtons__item_active'
    },
    raceConditions: {
        name: 'raceConditions',
        displayName: 'Race Conditions',
        switcherSelector: '.js-RC-customizeSettings__switcher_raceConditions',
        elementSelector: '.RC-raceCondition',
        elementHiddenClass: 'RC-raceCondition_hidden',
        btnCardSelector: null,
        btnCardActiveClass: null
    },
    owner: {
        name: 'owner',
        displayName: 'Owner',
        switcherSelector: '.js-RC-customizeSettings__switcher_owner',
        elementSelector: '.RC-runnerInfo_owner',
        elementHiddenClass: 'RC-runnerInfo_ownerHidden',
        btnCardSelector: null,
        btnCardActiveClass: null
    },
    quotes: {
        name: 'quotes',
        displayName: 'Quotes',
        switcherSelector: '.js-RC-customizeSettings__switcher_quotes',
        elementSelector: '.RC-quotes',
        elementHiddenClass: 'RC-quotes_hidden',
        btnCardSelector: '.js-RC-runnerQuoteBtn',
        btnCardActiveClass: 'RC-runnerButtons__item_active'
    },
    pedigrees: {
        name: 'pedigrees',
        displayName: 'Pedigrees',
        switcherSelector: '.js-RC-customizeSettings__switcher_pedigrees',
        elementSelector: '.RC-pedigree',
        elementHiddenClass: 'RC-pedigree_hidden',
        btnCardSelector: null,
        btnCardActiveClass: null
    },
    rtf: {
        name: 'rtf',
        displayName: 'RTF%',
        switcherSelector: '.js-RC-customizeSettings__switcher_rtf',
        elementSelector: '.js-RC-runnerInfo_rtf',
        elementHiddenClass: 'RC-runnerInfo__count_hidden',
        btnCardSelector: null,
        btnCardActiveClass: null
    },
    priceHistory: {
        name: 'priceHistory',
        displayName: 'Price History',
        switcherSelector: '.js-RC-customizeSettings__switcher_priceHistory',
        elementSelector: '.RC-historyPrices',
        elementHiddenClass: 'RC-historyPrices_hidden',
        btnCardSelector: null,
        btnCardActiveClass: null
    },
    decimalOdds: {
        name: 'decimalOdds',
        displayName: 'Decimal Odds',
        switcherSelector: '.js-RC-customizeSettings__switcher_decimalOdds',
        elementSelector: null,
        elementHiddenClass: null,
        btnCardSelector: null,
        btnCardActiveClass: null
    },
    bettingForecast: {
        name: 'bettingForecast',
        displayName: 'Betting Forecast',
        switcherSelector: '.js-RC-customizeSettings__switcher_bettingForecast',
        elementSelector: '.RC-raceFooterInfo_bettingForecast',
        elementHiddenClass: 'RC-raceFooterInfo_hidden',
        elementShownClass: 'RC-raceFooterInfo_shown',
        btnCardSelector: null,
        btnCardActiveClass: null
    },
    orderByPrice: {
        name: 'orderByPrice',
        displayName: 'Order by Price',
        switcherSelector: '.js-RC-customizeSettings__switcher_orderByPrice',
        elementSelector: null,
        elementHiddenClass: null,
        btnCardSelector: null,
        btnCardActiveClass: null
    },
    myRatings: {
        name: 'myRatings',
        displayName: 'My Ratings',
        switcherSelector: '.js-RC-customizeSettings__switcher_myRatings',
        elementSelector: '.RC-myRatings',
        elementHiddenClass: 'RC-myRatings_hidden',
        elementShownClass: 'RC-myRatings_shown',
        btnCardSelector: null,
        btnCardActiveClass: null
    },
    showPrices: {
        name: 'showPrices',
        displayName: 'Show Prices',
        switcherSelector: '.js-RC-customizeSettings__switcher_showPrices',
        elementSelector: '.RC-runnerRowPriceWrapper',
        elementHiddenClass: 'RC-showPrices_hidden',
        elementShownClass: 'RC-showPrices_shown',
        btnCardSelector: null,
        btnCardActiveClass: null
    },
    onInit(customizeSettings) {
        if (jQuery.cookie('customizeSettings')) {
            customizeSettings.setState(JSON.parse(jQuery.cookie('customizeSettings')));
        } else {
            customizeSettings.setState(customizeSettings.config.stateData);
        }
    },
    onShow(customizeSettings) {
        jQuery.cookie('customizeSettings', JSON.stringify(customizeSettings.config.stateData), {
            domain: `.${location.host.split('.').slice(1).join('.')}`,
            path: '/',
            expires: CUSTOMIZE_SETTINGS_COOKIE_EXPIRES
        });
    },
    onHide(customizeSettings) {
        jQuery.cookie('customizeSettings', JSON.stringify(customizeSettings.config.stateData), {
            domain: `.${location.host.split('.').slice(1).join('.')}`,
            path: '/',
            expires: CUSTOMIZE_SETTINGS_COOKIE_EXPIRES
        });
    }
};



// WEBPACK FOOTER //
// ./lib/js/modules/customizeSettings/customizeSettings.config.js